import { number, object } from "prop-types";
import { observer } from "mobx-react";
import { useEstimateEditorSettings } from "@tools";
import { TransferWorkload } from "@tools/EstimateEditor/components";
import { TimelineSectionChartContainer } from "./TimelineSectionChartContainer";
import { TimelineTeamMemberRemoveButton } from "../../TimelineTeamMemberRemoveButton";

export const TimelineTeamMemberChart = observer(({
  index,
  teamMember,
  section,
  workType,
  previousTeamMember,
  nextTeamMember,
  blocksStartDate,
}) => {
  const { allowEdition } = useEstimateEditorSettings();
  return (
    <TimelineSectionChartContainer
      element={teamMember}
      index={index}
      height="medium"
      type="teamMember"
      useValueMode
      editable
      rightActions={allowEdition && <TimelineTeamMemberRemoveButton
        teamMemberName={teamMember.name}
        sectionName={section.name}
        onRemove={teamMember.removeSelf}
        className="absolute apply-events"
        style={{ right: -42 }}
      />}
      blocksStartDate={blocksStartDate}
      topTransferContainer={
        allowEdition && previousTeamMember &&
        <TransferWorkload
          workType={workType}
          source={previousTeamMember}
          target={teamMember}
          placement="top"
        />
      }
      bottomTransferContainer={
        allowEdition && nextTeamMember &&
        <TransferWorkload
          workType={workType}
          source={teamMember}
          target={nextTeamMember}
          placement="bottom"
        />
      }
    />
  );
}
);

TimelineTeamMemberChart.propTypes = {
  index: number.isRequired,
  teamMember: object.isRequired,
  section: object.isRequired,
  workType: object.isRequired,
  previousTeamMember: object,
  nextTeamMember: object,
  blocksStartDate: object,
};
